// extracted by mini-css-extract-plugin
export default {"list":"TreatmentList--list--60f175","selectAllCheckbox":"TreatmentList--selectAllCheckbox--c1a45c"};